/**
 * @author - steves165
 */

/*global angular*/

(function() {

    /**
     *  Virgin Holidays Lightbox implementation.
     *
     *  @directive vholsLightbox - creates lightbox elements on the page.
     *  @directive lightboxControl - initializes the element that the lightbox is bound to.
     *
    **/
    angular.module('vholsLightBox', [])

        .directive('vholsLightbox', function() {
            return {
                replace: true,
                template: '<div class="light-box-outer"><div class="light-box-container"><div class="light-box"><i class="icon-x-symbol lightbox-close"></i><div class="light-box-content"></div></div></div></div>'
            }
        })

        .directive('lightboxControl', function() {
            return function($scope, $element) {
                $element.on('click', function(e) {
                    var $container = angular.element(document.querySelectorAll('.light-box-container'));
                    var $outer = angular.element(document.querySelectorAll('.light-box-outer'));
                    var $lightbox = angular.element(document.querySelectorAll('.light-box'));
                    var $lightboxContent = angular.element(document.querySelectorAll('.light-box-content'));

                    $outer.addClass('light-box-open');

                    'click touchstart'.split(' ').forEach(function(eventName) {
                        $container.on(eventName, function() {
                            $lightboxContent.html('');
                            $lightbox.removeClass('elements');
                            $outer.removeClass('light-box-open');
                        });
                    });

                    'click touchstart'.split(' ').forEach(function(eventName) {
                        $lightboxContent.on(eventName, function(e) {
                            e.stopPropagation();
                        });
                    });
                    e.preventDefault();
                });
            }
        })

        .directive('elementLightbox', function() {
            return {
                scope: {
                    lightboxTarget: '@'
                },
                link: function($scope, $element) {
                    $element.on('click', function() {
                        var $template = angular.element($element[0].querySelector($scope.lightboxTarget));
                        var contents = $template.html();
                        var $lightbox = angular.element(document.querySelectorAll('.light-box-content'));

                        $lightbox.parent().addClass('elements');

                        $lightbox.append(contents);
                    });
                }
            };
        });


    /**
     *  Virgin Holidays Youtube Lightbox implementation.
     *
     *  @directive youtubeTitle - retrieves the title of a video and binds it into paragraph tag.
     *  @directive youtubeVideo - retrieves a youtube video and bind the video into the lightbox.
     *
    **/
    angular.module('vholsYoutube', [])

        .directive('youtubeTitle', ['$http', function($http) {
            return {
                replace: false,
                transclude: true,
                scope: {
                    videoId: '@',
                    titleStart: '@'
                },
                link: function($scope) {
                    var url = '//gdata.youtube.com/feeds/api/videos/' + $scope.videoId + '?v=2&alt=jsonc';

                    var getTitle = function(resp) {
                        $scope.title = resp.data.data.title;
                    };

                    $http({
                        method: "GET",
                        url: url,
                        cache: true
                    }).then(getTitle);
                },
                template: '<p class="tts-video-pod-title qa-tts-video-pod-title"><strong>{{titleStart}} </strong>{{title}}</p>'
            };
        }])

        .directive('youtubeVideo', function() {
            return {
                link: function($scope, $element) {
                    $element.on('click', function() {
                        var videoUrl = 'http://www.youtube.com/embed/' + $element.attr('youtube-video');
                        var template = "<div class='youtube-video-container'><iframe class='youtube-video' src='" + videoUrl + "' frameborder='0' allowfullscreen></iframe></div>";

                        angular.element(document.querySelectorAll('.light-box-content')).append(template);
                    });
                }
            }
        });

    angular.module('vholsIframeLb', [])

        .directive('vholsIframe', function() {
            return {
                replace: false,
                scope: {
                    iframeSrc: '@',
                    iframeName: '@'
                },
                link: function($scope, $element) {
                    $element.on('click', function() {
                        var template = '<iframe src="' + $scope.iframeSrc + '" name="' + $scope.iframeName + '" style="height:600px;width:100%"></iframe>';
                        angular.element(document.querySelectorAll('.light-box-content')).append(template);
                    });
                }
            };
        });
})();
